import { Welcome } from "components";
import React, { useEffect } from "react";
import SummaryCards from "./SummaryCards";
import { useSelector } from "react-redux";

import PMSalesTerminalDashboard from "./PMSalesTerminalDashboard";
import { getTransactionTypes } from "redux/actions/transactionActions";
import PMOperationsTerminalDashboard from "./PMOperationsTerminalDashboard";
import PMAuthorizerTerminalDashboard from "./PmAuthorizerTerninalDashboard";

const TerminalTransactions = () => {
  useEffect(() => {
    getTransactionTypes();
  }, []);

  const { user } = useSelector((state) => state.user);

  const getDashboardToDisplay = () => {
    if (user?.roles.includes("PM Approver")) {
      return <PMAuthorizerTerminalDashboard />;
    } else if (user?.roles.includes("PM Operations")) {
      return <PMOperationsTerminalDashboard />;
    } else {
      return <PMSalesTerminalDashboard />;
    }
  };

  return (
    <div className="dashboard-page-container terminal-stats-dashboard admin-terminal-dashboard">
      <Welcome />
      <div className="mt-2">
        <SummaryCards />
        {getDashboardToDisplay()}
      </div>
    </div>
  );
};

export default TerminalTransactions;
